module.exports = __webpack_public_path__ + "static/media/Cover.edb258fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Cover.png
// module id = 27
// module chunks = 0